export const STATUSES = {
	READY_FOR_INVOICING: 0,
	NEEDS_APPROVAL: 1,
	INVOICED: 2,
	DENIED: 3,
	CREATED_PROFORMA: 4,
	EXPIRED: 5,
};
